import {
  DbotEventDispatcher,
  DocumentContext,
  DocumentTypeHandler,
  mapDocumentLanguageToLocales,
} from "@/dbot/common/commonDomain";
import { BoardMeetingMinutes, incompetentBoardMembersToJson } from "./boardMeetingMinutesDomain";
import { BoardMeetingMinutesForm } from "./BoardMeetingMinutesForm";
import { DocumentType } from "@/common/documents";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DocumentContext<BoardMeetingMinutes>,
): BoardMeetingMinutesForm {
  return new BoardMeetingMinutesForm(context, dispatch);
}

export function applyForm(form: BoardMeetingMinutesForm): BoardMeetingMinutes {
  return {
    type: DocumentType.board_meeting,
    boardMeetingForm: form.boardMeetingForm.value,
    meetingPlace: form.meetingPlace.value,
    inlineAddress: form.inlineAddress.validatedValue,
    selectedSigningBoardMembers: form.selectedSigningBoardMembers.selected,
    optionalSignatories: [
      ...form.selectedSigningNotParticipatingBoardMembers.selected.map((m) => m.companyroleId),
      ...form.selectedSigningCeos.selected.map((m) => m.companyroleId),
      ...form.selectedSigningObservers.selected.map((m) => m.companyroleId),
    ],
    extraSignatories: form.extraSignatories.selected,
    meetingChair: form.meetingChair?.value,
    boardMeetingVotes: Array.from(form.votesByDecision.values()).map((v) => v.toJSON()),
    deadlineForNotes: form.deadlineForNotes.toISOString(),
    numberOfBoardMembers: form.numberOfBoardMembers,
    incompetentBoardMembers: incompetentBoardMembersToJson(form.incompetentBoardMembers),
    documentLanguage: mapDocumentLanguageToLocales(form.documentLanguage.value),
    physicalMeetingSignersMode: form.physicalMeetingSignersMode.value,
    board: form.board.slice(),
    participants: [
      ...form.selectedBoardMembers.selected.map((m) => m.companyroleId),
      ...form.selectedDeputyMembers.selected.map((m) => m.companyroleId),
      ...form.selectedCeos.selected.map((m) => m.companyroleId),
      ...form.selectedObservers.selected.map((m) => m.companyroleId),
    ],
    extraParticipants: form.extraParticipants.slice(),
    additionalDetailsTexts: form.additionalDetailsTextModel.localizedTexts,
    additionalParticipantDetailsTexts: form.additionalParticipantDetailsTextModel.localizedTexts,
  };
}

export const boardMeetingMinutesHandler: DocumentTypeHandler<
  DocumentType.board_meeting,
  BoardMeetingMinutes,
  BoardMeetingMinutesForm
> = {
  type: DocumentType.board_meeting,
  initNewForm,
  initForm: (form) => form.init(),
  applyForm,
  handleEvent: (form, event) => form.handleEvent(event),
  validate: (form) => form.validate(),
};
